
<div class="tuk-spin" :class="{ picante: isPicante() }" :style="{ width: size + 'px', height: size + 'px' }">
  <div class="tuk-spin-ring" />
  <div class="tuk-spin-logo" />
</div>
